<template>
  <div class="welcome-screen">
      <div class="welcome-card">
          <div class="welcome-header">
              <section class="w-full py-6 md:py-12 lg:py-16 xl:py-24">
                  <div class="container px-4 md:px-6">
                      <div class="flex flex-col items-center space-y-2 text-center">
                          <div class="space-y-2">
                              <span class="welcome-title text-2xl font-bold tracking-tighter sm:text-3xl md:text-4xl lg:text-5xl/none break-words mb-3">
                                  <CRow >
                                      <CCol sm="1" md="2">
                                          <CIcon
                                              style="width: 3.5rem; height: 3.5rem; color: #2E2860;"
                                              :content="$options.freeSet.cilMoodVeryGood"
                                          />
                                      </CCol>
                                      <CCol sm="10" md="10">
                                          <span class="welcome-title text-2xl font-bold tracking-tighter sm:text-3xl md:text-4xl lg:text-5xl/none break-words mb-3">
                                              <!--<span class="mr-2">
                                                  <CIcon
                                                      style="width: 5rem; height: 5rem; color: #2E2860;"
                                                      :content="$options.freeSet.cilMoodVeryGood"
                                                  />
                                              </span>-->
                                              <span ref="titleText" class="animated-text"></span>
                                              <span ref="titleText2" class="animated-text user-name"></span>
                                              <!--<span ref="titleText3" class="animated-text"></span>-->
                                          </span>
                                      </CCol>

                                  </CRow>
                              </span>
                                      
                             
                              <!--<p class="user-greeting mt-4 text-xl break-words">
                                  <span ref="greetingText" class="animated-text"></span>
                                  <span ref="userNameText" class="user-name font-semibold animated-text"></span>
                              </p>-->
                              <p class="welcome-message max-w-full text-gray-500 md:text-lg break-words text-left mt-2">
                                  <span ref="welcomeMessageText" class="animated-text"></span>
                              </p>
                              <p class="support-message text-sm mt-6 break-words text-left">
                                  <span ref="supportMessageText" class="animated-text" style="font-style: oblique"></span>
                              </p>
                              <p class="text-left">
                                  <a href="mailto:soporte@vapp.cl"
                                      class="support-email text-blue-600 hover:underline">
                                      <span ref="emailText" class="animated-text"></span>
                                  </a>
                              </p>
                          </div>
                          <!--<div class="space-y-4 mt-6">
                <input
                  v-model="nombreUsuario"
                  class="px-3 py-1 border rounded-md text-sm w-full max-w-xs"
                  placeholder="Ingresa tu nombre"
                  @keyup.enter="updateGreeting"
                />
                <div class="space-x-4">
                  <button
                    class="inline-flex h-8 items-center justify-center rounded-md bg-gray-900 px-3 py-1 text-xs font-medium text-gray-50 shadow transition-colors hover:bg-gray-900/90 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-gray-950 disabled:pointer-events-none disabled:opacity-50"
                    @click="updateGreeting"
                  >
                    Comenzar
                  </button>
                  <button
                    class="inline-flex h-8 items-center justify-center rounded-md border border-gray-200 bg-white px-3 py-1 text-xs font-medium shadow-sm transition-colors hover:bg-gray-100 hover:text-gray-900 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-gray-950 disabled:pointer-events-none disabled:opacity-50"
                  >
                    Saber más
                  </button>
                </div>
              </div>-->
                      </div>
                      
                  </div>
                  <!--<div class="mt-3">
                          <center>
                              <CInput
                                  placeholder="Sugerencias"
                                  size="sm"
                                  style="margin-top:0"
                                  v-model="sugerencia"
                                  type="text"
                                  horizontal
                              />

                          </center>
                          
                      </div>-->
              </section>
          </div>
      </div>
  </div>
</template>

<script>
import { freeSet } from "@coreui/icons";

export default {
  name: "PrincipalUsuario",
  freeSet,
  data() {
      return {
          nombreUsuario: this.getUserName(),
          texts: {
              title: 'Bienvenid@ a Gesto ',
              title2: '{userName}.',
              title3: '',
              greeting: 'Hola, ',
              welcomeMessage: 'Nos alegra verte por aquí. Esperamos que tengas una excelente experiencia.',
              supportMessage: 'Deseamos que tengas un buen día y recuerda que puedes contactarnos en ',
              email: 'soporte@vapp.cl',
              sugerencia: '',
          }
      };
  },
  mounted() {
      this.animateAllTexts()
  },
  methods: {
      getUserName() {
          try {
              const userLogginToken = JSON.parse(this.$cookie.get("userLogginToken"));
              if (userLogginToken.tipoUsuario === "trabajador") {
                  return userLogginToken.nombreTrabajador.split(" ")[0];
              } else {
                  return userLogginToken.nombreUsuario;
              }
          } catch (error) {
              console.error("Error al obtener el nombre de usuario:", error);
              return "Invitado";
          }
      },
      updateGreeting() {
          this.animateAllTexts()
      },
      animateText(element, text, animate, tiempo) {
          if(animate){
              return new Promise(resolve => {
                  element.textContent = ''
                  let i = 0
                  const timer = setInterval(() => {
                      if (i < text.length) {
                          element.textContent += text.charAt(i)
                          i++
                      } else {
                          clearInterval(timer)
                          resolve()
                      }
                  }, tiempo) // Ajusta este valor para cambiar la velocidad de la animación
              })
          } else{
              element.textContent = text
          }
      },
      async animateAllTexts() {
          const elements = [
              { ref: 'titleText', text: this.texts.title, animate: true, tiempo: 50 },
              { ref: 'titleText2', text: this.texts.title2.replace('{userName}', this.nombreUsuario), animate: true, tiempo: 50 },
              //{ ref: 'titleText3', text: this.texts.title3, animate: true, tiempo: 50},
              /*{ ref: 'greetingText', text: this.texts.greeting },
              { ref: 'userNameText', text: this.nombreUsuario },*/
              { ref: 'welcomeMessageText', text: this.texts.welcomeMessage, animate: true, tiempo: 50 },
              { ref: 'supportMessageText', text: this.texts.supportMessage, animate: true, tiempo: 50 },
              { ref: 'emailText', text: this.texts.email, animate: true, tiempo: 50 }
          ]

          for (const el of elements) {
              await this.animateText(this.$refs[el.ref], el.text, el.animate, el.tiempo)
          }
      }
  },
};
</script>

<style scoped>
.animated-text {
  display: inline;
  vertical-align: middle;
  white-space: normal;
  overflow: visible;
}

.welcome-title {
  color: #333;
  font-size: 1.3rem;
  line-height: 1;
  font-weight: 600;
  margin: 0;
  white-space: normal;
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-word;
}

.user-name {
  color: #2563eb;
  font-weight: 500;
}

.support-email {
  font-size: 1.4rem;
  color: #4a90e2;
  text-decoration: none;
}

.support-email:hover {
  text-decoration: underline;
}

.welcome-screen {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 50vh;
  padding: 1rem;
}

.welcome-card {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 2rem;
  max-width: 500px;
  height: auto;
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-word;
}

.welcome-header {
  display: flex;
  align-items: center;
  margin-bottom: 1.5rem;
}

.user-greeting {
  font-size: 1.1rem;
  color: #4b5563;
  margin-bottom: 0.5rem;
  white-space: normal;
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-word;
}

.welcome-message,
.support-message {
  font-size: 0.9rem;
  color: #6b7280;
  line-height: 1.4;
  white-space: normal;
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-word;
}
</style>